import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';

export function ProfileDebug() {
  const { user, profile, isAdmin, isClient, refreshProfile } = useAuth();

  return (
    <Card className="max-w-md hidden">
      <CardHeader>
        <CardTitle>Debug: Profile Info</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div>
          <strong>User ID:</strong> {user?.id || 'None'}
        </div>
        <div>
          <strong>Email:</strong> {profile?.email || 'None'}
        </div>
        <div>
          <strong>Role:</strong> {profile?.role || 'None'}
        </div>
        <div>
          <strong>Is Admin:</strong> {isAdmin ? 'Yes' : 'No'}
        </div>
        <div>
          <strong>Is Client:</strong> {isClient ? 'Yes' : 'No'}
        </div>
        <Button onClick={refreshProfile} className="w-full">
          Refresh Profile
        </Button>
      </CardContent>
    </Card>
  );
}